// Module
var code = " <div class=\"title\"> {{ title }} <button type=\"button\" mat-icon-button=\"\" class=\"shrinked-icon-button\" (click)=\"onClose($event)\"> <mat-icon svgIcon=\"gh:close\" class=\"s18 icon-close\" (click)=\"onClose($event)\"></mat-icon> </button> </div> <div class=\"message\" [ghEllipsis]=\"text\"></div>";
// Exports
module.exports = code;